import  styled from "@emotion/styled";

export const PageHeader = styled.h1`
  font-size: 3rem;
  line-height: 1.166;
  text-align: center;
  font-weight: normal;
  margin: 0 0 32px 0;
`;